module.exports = __webpack_public_path__ + "img/个人空间暗.09f0886d.png";